/* eslint-disable react/prop-types */
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogActions from '@mui/material/DialogActions'
import TextField from '@mui/material/TextField'
import Button from '@mui/material/Button'
import PlansSelect from './PlansSelect'
import UsageTypeSelect from './UsageTypeSelect'

function sanitizeFeatureName(value) {
  return value.replace(/[^a-zA-Z0-9_-]/g, '')
}

function CreateFeatureDialog({
  open,
  name,
  description,
  usageType,
  plans,
  onNameChange,
  onDescriptionChange,
  onUsageTypeChange,
  onPlansChange,
  onCancel,
  onSubmit,
}) {
  const disabled = name.trim() === ''

  return (
    <Dialog open={open} onClose={onCancel} fullWidth maxWidth="sm">
      <DialogTitle>Nova feature</DialogTitle>
      <DialogContent>
        <TextField
          label="Nome"
          value={name}
          onChange={(event) => onNameChange(sanitizeFeatureName(event.target.value))}
          fullWidth
          required
          margin="normal"
          autoFocus
          helperText="Apenas letras, números, hífen e underscore — sem espaços ou outros caracteres especiais."
        />
        <TextField
          label="Descrição"
          value={description}
          onChange={(event) => onDescriptionChange(event.target.value)}
          fullWidth
          multiline
          minRows={2}
          margin="normal"
        />
        <PlansSelect labelId="create-plans-label" value={plans} onChange={onPlansChange} />
        <UsageTypeSelect labelId="create-usage-type-label" value={usageType} onChange={onUsageTypeChange} />
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel}>Cancelar</Button>
        <Button variant="contained" disabled={disabled} onClick={onSubmit}>
          Criar
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default CreateFeatureDialog
